import React, { useState } from 'react';
import { useField } from 'formik';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { FormItemCheckboxField } from 'components/form-item/form-item-checkbox-field';

import { ConfirmationPrivateInfoDialog } from './confirmation-private-info-dialog';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    label: {
      color: '#000',
    },
    link: {
      color: theme.palette.primary.main,
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  })
);

interface ConfirmationCheckboxProps {
  name: string;
}
export function ConfirmationPrivateInfoCheckbox({
  name,
}: ConfirmationCheckboxProps) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const [field, , helpers] = useField<boolean>(name);

  const value: boolean = field.value || false;

  const handleChange = (value: boolean) => {
    helpers.setValue(value);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleConfirm = () => {
    setOpen(false);
    handleChange(true);
  };

  return (
    <>
      <ConfirmationPrivateInfoDialog
        open={open}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
      />
      <FormItemCheckboxField
        name={name}
        disabled={!value}
        label={
          <span className={classes.label}>
            Seznámil jsem se s{' '}
            <span className={classes.link} onClick={handleOpen}>
              poučením o zpracování osobních údajů
            </span>
            .
          </span>
        }
      />
    </>
  );
}
